<template>
  <div>
    <v-card>
      <v-card-title>
        {{ modoEdicao ? 'Adicionar Novo Cartão' : 'Selecione seu Cartão' }}
      </v-card-title>
      <v-card-text>
        <div v-if="!modoEdicao">
          <v-list v-if="cartoes.length > 0">
            <v-list-item
              v-for="(cartao, index) in cartoes"
              :key="index"
              @click="cartaoSelecionado = index"
              :class="{ 'cartao-selecionado': cartaoSelecionado === index }"
            >
              <template v-slot:prepend>
                <v-icon :color="getBandeiraCor(getBandeira(cartao.bandeira))" class="mr-3">
                  mdi-credit-card
                </v-icon>
              </template>
              <v-list-item-title>
                {{ cartao.nome_titular }}
                <v-icon v-if="cartaoSelecionado === index" color="green" class="ml-2">
                  mdi-check-circle
                </v-icon>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ formatarNumeroCartao(cartao.suffix) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ getBandeira(cartao.bandeira) }} - {{ formatDataExpiracao(cartao.expiration_date) }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <v-alert v-else type="info">
            Nenhum cartão cadastrado
          </v-alert>
        </div>
        <v-form v-else ref="formCartao" class="pa-4">
          <v-row>
            <v-col cols="12">
              <span class="text-grey">Número do cartão:</span>
              <v-row class="d-flex">
                <v-col v-for="(part, index) in cardParts" :key="index" cols="3">
                  <v-text-field
                    variant="underlined"
                    color="primary"
                    v-model="cardParts[index]"
                    maxlength="4"
                    :ref="(el) => cardRefs[index] = el"
                    @keydown="handleKeydownCard(index, $event)"
                    @input="handleInputCard(index)"
                    :rules="[
                      v => !!v || 'Campo obrigatório',
                      v => v.length === 4 || '4 dígitos necessários'
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                variant="underlined"
                color="primary"
                v-model="novoCartao.nome_titular"
                label="Nome no Cartão"
                :rules="nomeRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                variant="underlined"
                color="primary"
                label="Validade (MM/AAAA)"
                v-model="novoCartao.data"
                :rules="[
                  v => !!v || 'Validade é obrigatória',
                  v => validateExpirationDate(v) || 'Data inválida'
                ]"
                @input="formatarValidade"
                maxlength="7"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                variant="underlined"
                color="primary"
                label="CVV"
                v-model="novoCartao.cvv"
                :rules="[
                  v => !!v || 'CVV é obrigatório',
                  v => (v && v.length >= 3 && v.length <= 4) || 'CVV inválido'
                ]"
                maxlength="4"
                type="password"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <template v-if="!modoEdicao">
          <v-btn
            color="red darken-1"
            @click="modoEdicao = true"
          >
            Inserir Novo Cartão
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="$emit('voltar')"
          >
            Voltar
          </v-btn>
          <v-btn
            color="green darken-1"
            @click="confirmarSelecao"
            :disabled="cartaoSelecionado === null"
          >
            Confirmar Cartão
          </v-btn>
        </template>
        <template v-else>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="modoEdicao = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            @click="salvarCartao"
            :loading="salvando"
          >
            Salvar Cartão
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { tokenizandoCartao } from '../libs/tokenizacao';
import { onAuthStateChanged, getAuth } from "firebase/auth";
import getDatabase from "../libs/getDatabase";
import { getCards } from "../libs/getCard"
import { updateCard } from "../libs/updateCard"

export default {
  name: 'DialogCard',
  data() {
    return {
      modoEdicao: false,
      salvando: false,
      cartaoSelecionado: null,
      cardParts: ['', '', '', ''],
      cardRefs: [],
      cartoes: [],
      novoCartao: {
        nome_titular: '',
        numero: '',
        bandeira: '',
        data: '',
        cvv: ''
      },
      bandeiras: [
        'Visa',
        'Mastercard',
      ],
      nomeRules: [
        val => (this.validarNome(val) || 'Nome Inválido'),
        val => (val != '' || 'Insira seu nome')
      ],
      user: null,
      database: null,
      cartaoTokenizadoSalvo: null 
    }
  },
  watch: {
    cardParts: {
      handler(newVal) {
        this.novoCartao.numero = newVal.join('')
        this.detectarBandeira()
      },
      deep: true
    }
  },
  methods: {
    validarNome(val) {
      const regexCaracteres = /^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$/;
      const regexEspacos = /[ ]{2,}/;
      return regexCaracteres.test(val) && !regexEspacos.test(val);
    },
    formatarNumeroCartao(numero) {
      if (!numero) return '';
      const numFinal = '**** **** **** '+numero;
      return numFinal;
    },
    detectarBandeira() {
      const numero = this.novoCartao.numero;
      if (/^4/.test(numero)) {
        this.novoCartao.bandeira = 'Visa';
      } else if (/^5[1-5]/.test(numero)) {
        this.novoCartao.bandeira = 'Mastercard';
      } else if (/^3[47]/.test(numero)) {
        this.novoCartao.bandeira = 'American Express';
      } else if (/^6/.test(numero)) {
        this.novoCartao.bandeira = 'Elo';
      } else {
        this.novoCartao.bandeira = '';
      }
    },
    getBandeiraCor(bandeira) {
      const cores = {
        'Visa': '#1a1f71',
        'Mastercard': '#eb001b',
      };
      return cores[bandeira] || '#666';
    },
    getBandeira(authorization_code) {
      const bandeira = (authorization_code == 2) ? 'Mastercard' : 'Visa';
      return bandeira
    },
    validateExpirationDate(date) {
      if (!date) return false;
      const [mes, ano] = date.split('/');
      if (!mes || !ano || mes.length !== 2 || ano.length !== 4) return false;
      const mesNum = parseInt(mes, 10);
      const anoNum = parseInt(ano, 10);
      if (isNaN(mesNum) || isNaN(anoNum)) return false;
      if (mesNum < 1 || mesNum > 12) return false;
      const hoje = new Date();
      const dataExp = new Date(`${anoNum}-${mesNum}-01`);
      return dataExp >= new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    },
    formatarValidade(e) {
      let valor = e.target.value.replace(/\D/g, '');
      if (valor.length >= 2) {
        valor = valor.slice(0, 2) + '/' + valor.slice(2);
      }
      if (valor.length > 7) {
        valor = valor.slice(0, 7);
      }
      this.novoCartao.data = valor;
    },
    handleInputCard(index) {
      if (this.cardParts[index].length === 4 && index < 3) {
        this.$nextTick(() => {
          const nextInput = this.cardRefs[index + 1]?.$el?.querySelector('input');
          nextInput?.focus();
        });
      }
    },
    formatDataExpiracao(data) {
      const data_formatada = data.slice(0, 2) + '/' + data.slice(2);
      return data_formatada
    },
    handleKeydownCard(index, event) {
      if (event.key === 'Backspace' && this.cardParts[index] === '' && index > 0) {
        this.$nextTick(() => {
          const prevInput = this.cardRefs[index - 1]?.$el?.querySelector('input');
          prevInput?.focus();
        });
      }
    },
    async confirmarSelecao() {
      if (this.cartaoSelecionado !== null) {
        if (this.cartaoTokenizadoSalvo != null) {
          const atualizaToken = await updateCard(this.cartaoTokenizadoSalvo, this.database.cnpj);
          console.log('Cartão atualizado? ', atualizaToken)
          this.$emit('cartao-selecionado', true);
          this.$emit('voltar');
        } else {
          const cartao_selecionado = this.cartaoSelecionado;
          const token_cartao = this.cartoes[cartao_selecionado].token;
          const atualizaToken = await updateCard(token_cartao, this.database.cnpj);
          console.log('Cartão atualizado? ', atualizaToken)
          this.$emit('cartao-selecionado', true);
          this.$emit('voltar');
        }
      }
    },
    async salvarCartao() {
      if (!this.$refs.formCartao.validate()) return;
      this.salvando = true;
      try {
        const dadosDoCartao = {
          numero: this.cardParts.join(''),
          nome_titular: this.novoCartao.nome_titular,
          bandeira: this.novoCartao.bandeira,
          data: this.novoCartao.data,
          cvv: this.novoCartao.cvv
        };
        const cartaoTokenizado = await tokenizandoCartao(dadosDoCartao, this.database.cnpj);
        this.cartaoTokenizadoSalvo = cartaoTokenizado;
        this.cardParts = ['', '', '', ''];
        this.novoCartao = {
          nome_titular: '',
          numero: '',
          bandeira: '',
          data: '',
          cvv: ''
        };
        this.modoEdicao = false;
        this.cartaoSelecionado = this.cartoes.length - 1;
      } catch (error) {
        console.error('Erro ao salvar ou tokenizar o cartão:', error);
        alert('Falha ao salvar o cartão. Tente novamente.');
      } finally {
        this.salvando = false;
        this.listarCartoes();
      }
    },
    async listarCartoes() {
      if (this.user && this.database) {
        try {
          const response = await getCards(this.database.cnpj);
          this.cartoes = response; 
        } catch (error) {
          console.error("Erro ao carregar os cartões: ", error);
          this.cartoes = [];
        }
      } else {
        console.warn("Usuário ou banco de dados não estão disponíveis. Não foi possível listar os cartões.");
      }
    }
  },
  async created() {
    onAuthStateChanged(getAuth(), async (user) => {
      if (user) {
        this.user = user;
        try {
          this.database = await getDatabase(user);
          this.listarCartoes();
        } catch (error) {
          console.error("Erro ao obter o banco de dados:", error);
        }
      }
    });
  }
}
</script>

<style scoped>
.cartao-selecionado {
  background-color: rgba(0, 150, 136, 0.1);
  border-left: 4px solid #009688;
}

.v-list-item {
  cursor: pointer;
  transition: all 0.3s ease;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.v-text-field {
  font-size: 14px;
}
</style>